import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/HeatGain";

export const HEAT_GAIN_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Update = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Update/:id`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export const Calculate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Calculate`, options);

export const GetBuildingMaterials = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBuildingMaterials`, options);

export const GetInsulationMaterials = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetInsulationMaterials`, options);

export const GetMetallicMaterials = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetMetallicMaterials`, options);

export const CalculateHeatGainDoubleRoomC1 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateHeatGainDoubleRoomC1`, options);

export const CalculateHeatGainDoubleRoomC2 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateHeatGainDoubleRoomC2`, options);

export const CalculateHeatGainDoubleRoomC3 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateHeatGainDoubleRoomC3`, options);

export const AddHeatGainDoubleRoomC1 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddHeatGainDoubleRoomC1`, options);

export const AddHeatGainDoubleRoomC2 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddHeatGainDoubleRoomC2`, options);

export const AddHeatGainDoubleRoomC3 = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddHeatGainDoubleRoomC3`, options);

export const GetHeatGainDoubleRooms = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetHeatGainDoubleRooms`, options);

export const GetHeatGainDoubleRoomById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetHeatGainDoubleRoom/:id`, options);

export const DeleteHeatGainDoubleRoom = (options) =>
  GENERATE_URL(`${PREFIX_URL}/DeleteHeatGainDoubleRoom/:id`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Calculate,
  GetBuildingMaterials,
  GetInsulationMaterials,
  GetMetallicMaterials,
  CalculateHeatGainDoubleRoomC1,
  CalculateHeatGainDoubleRoomC2,
  CalculateHeatGainDoubleRoomC3,
  AddHeatGainDoubleRoomC1,
  AddHeatGainDoubleRoomC2,
  AddHeatGainDoubleRoomC3,
  GetHeatGainDoubleRooms,
  GetHeatGainDoubleRoomById,
  DeleteHeatGainDoubleRoom,
};
